<template>
  <div class="promoted_setting">
    <el-form
      ref="ruleForm"
      :rules="rules"
      :model="ruleForm"
      class="unify-box"
      label-width="auto"
    >
      <p class="title">办赛金额设置</p>
      <el-row :gutter="24">
        <el-col :md="24" :sm="24">
          <el-form-item label="" style="width: 250px" prop="">
            单项赛: 是否需要缴纳费用？
          </el-form-item>
          <el-form-item label="" prop="singleFeeFlag">
            <el-radio-group
              v-model="ruleForm.singleFeeFlag"
              @input="singleRadioValChange"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="!singleIsDisabled"
            label=""
            style="width: 360px; margin-left: 100px"
            prop="singleAmount"
          >
            <el-input
              v-model="ruleForm.singleAmount"
              placeholder="保留两位小数"
              type="number"
              min="0"
            ></el-input>
            元
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :md="24" :sm="24">
          <el-form-item label="" style="width: 250px" prop="">
            团体赛: 是否需要缴纳费用？
          </el-form-item>
          <el-form-item label="" prop="teamFeeFlag">
            <el-radio-group
              v-model="ruleForm.teamFeeFlag"
              @input="teamRadioValChange"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label=""
            style="width: 360px; margin-left: 100px"
            prop="teamAmount"
            v-if="!teamIsDisabled"
          >
            <el-input
              v-model="ruleForm.teamAmount"
              placeholder="保留两位小数"
              type="number"
              min="0"
            ></el-input>
            元
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24"> </el-row>
      <el-form-item style="margin-left: 180px; margin-top: 20px">
        <div class="btnWrap">
          <el-button
            type="primary"
            :disabled="isDisabled"
            @click="submitForm('ruleForm')"
            >确认</el-button
          >
          <el-button @click="resetForm('ruleForm')" :disabled="isDisabled"
            >取消</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    // const reg = /^[1-9]\d*$/;
    // const ValidatorRules = (rule, value, callback) => {
    //   if (value == null) {
    //     callback(new Error("请输入"));
    //   } else if (reg.test(value)) {
    //     callback(new Error("请输入大于零的数"));
    //   } else {
    //     callback();
    //   }
    // };

    return {
      rules: {
        singleFeeFlag: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        teamFeeFlag: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        singleAmount: [{ required: true, message: '请输入金额', trigger: "blur" }],
        teamAmount: [{ required: true, message: '请输入金额', trigger: "blur" }],
      },
      ruleForm: {
        singleFeeFlag: "",
        singleAmount: "",
        teamFeeFlag: "",
        teamAmount: "",
      },
      singleIsDisabled: false,
      teamIsDisabled: false,
      isDisabled: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取每日扫描的会员晋级系统配置
    getData() {
      this.$http({
        url: this.$http.adornUrl("/sys/config/getSelfMatchFeeConfig"),
        method: "get",
      }).then((data) => {
        if (data.code == 0) {
          let resData = data.data;
          this.ruleForm.singleFeeFlag = resData.single.feeFlag;
          this.singleIsDisabled = resData.single.feeFlag == "1" ? false : true;
          this.ruleForm.singleAmount = resData.single.amount;
          this.ruleForm.teamFeeFlag = resData.team.feeFlag;
          this.teamIsDisabled = resData.team.feeFlag == "1" ? false : true;
          this.ruleForm.teamAmount = resData.team.amount;
        }
      });
    },
    save() {
      let intervalOfDay = -this.ruleForm.intervalOfDay;
      let data = this.$http.adornData({
        single: {
          feeFlag: this.ruleForm.singleFeeFlag,
          amount: Number(this.ruleForm.singleAmount).toFixed(2),
        },
        team: {
          feeFlag: this.ruleForm.teamFeeFlag,
          amount: Number(this.ruleForm.teamAmount).toFixed(2),
        },
      });
      this.$http({
        url: this.$http.adornUrl("/sys/config/updateSelfMatchFeeConfig"),
        method: "post",
        data,
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success(data.msg);
        }
      });
    },
    singleRadioValChange(val) {
      console.log(this.ruleForm);
      this.singleIsDisabled = val == 1 ? false : true;
    },

    teamRadioValChange(val) {
      console.log(this.ruleForm);
      this.teamIsDisabled = val == 1 ? false : true;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss">
.promoted_setting {
  width: 90%;
  margin: 40px auto 0;
  .unify-box {
    margin: 40px auto 0;
    border: 1px solid rgb(187, 187, 187);
    border-radius: 10px;
    padding: 30px 80px 20px;
    position: relative;
    .el-input {
      width: 70%;
    }
    .el-form-item {
      display: inline-block;
      // width: 250px;
    }
    // .el-form-item__label-wrap,
    // .el-form-item__content {
    //   margin-left: 0 !important;
    // }
    .el-form-item__label {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
    }
    .btnWrap {
      display: flex;
      justify-content: center;
      .el-button {
        width: 118px;
      }
      .el-button--primary {
        background: rgb(129, 179, 55);
        color: #fff;
        margin-right: 30px;
      }
    }
    .title {
      width: 150px;
      font-size: 14px;
      text-align: center;
      background: #fff;
      position: absolute;
      top: -11px;
      left: 50px;
      letter-spacing: 1px;
      margin: 0; //去除默认属性影响
    }
    .gap {
      font-weight: bold;
      color: rgb(16, 16, 16);
      margin: 0 10px;
    }
    .number {
      width: 300px;
    }
    .label {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
      margin-right: 12px;
    }
    .pay-inp {
      width: 200px;
      margin-right: 5px;
    }
    .gap-top {
      margin-top: 20px;
    }
  }
}
</style>